import React, { useRef, useEffect } from 'react';

import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

function InputMaxLength({
  name,
  label,
  getValue,
  serialize,
  disabled,
  isGrid,
  maxLength, // Nova prop para limitar o número de caracteres
  maxValue, // Limita o valor máximo permitido
  ...rest
}) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  function handleChangeValue(event) {
    let { value } = event.target;

    // Remove tudo que não for número
    value = value.replace(/\D/g, '');

    // Aplica a restrição de tamanho se maxLength estiver definido
    if (maxLength) {
      value = value.slice(0, maxLength);
    }

    // Impede que o valor ultrapasse o máximo permitido
    if (maxValue && Number(value) > maxValue) {
      value = String(maxValue);
    }

    // Atualiza o input corretamente
    event.target.value = value;
    inputRef.current.value = serialize(value);
    getValue(serialize(value));
  }

  // function handleChangeValue(event) {
  //   let { value } = event.target;

  //   if (maxLength && rest.type === "number") {
  //     value = value.replace(/\D/g, ""); // Remove tudo que não for número
  //     if (value.length > maxLength) {
  //       value = value.slice(0, maxLength); // Mantém apenas os primeiros 'maxLength' números
  //     }
  //   }

  //   // Atualiza o input
  //   event.target.value = value;
  //   inputRef.current.value = serialize(value);
  //   getValue(serialize(value));
  // }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    inputRef.current.value = defaultValue;
    if (defaultValue) getValue(serialize(defaultValue));
  }, [defaultValue]);

  useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <FormControl style={{ width: '100%' }}>
      <TextField
        ref={inputRef}
        onChange={handleChangeValue}
        error={!!error}
        defaultValue={t(defaultValue)}
        label={label}
        variant="outlined"
        fullWidth
        id={name}
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*', // Força apenas números no teclado mobile
        }}
        {...rest}
        disabled={(permission || disabled) && !isGrid}
        onFocus={clearError}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

InputMaxLength.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  serialize: PropTypes.func,
  disabled: PropTypes.bool,
  isGrid: PropTypes.bool,
  maxLength: PropTypes.string,
  maxValue: PropTypes.string,
};

InputMaxLength.defaultProps = {
  getValue: () => {},
  serialize: (value) => value,
  disabled: false,
  isGrid: false,
  maxLength: undefined,
  maxValue: undefined,
};

export default InputMaxLength;

/*
import React, { useRef, useEffect } from 'react';

import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

function Input({
  name,
  label,
  getValue,
  serialize,
  disabled,
  isGrid,
  ...rest
}) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  function handleChangeValue(event) {
    const { value } = event.target;

    inputRef.current.value = serialize(value);

    getValue(serialize(value));
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    inputRef.current.value = defaultValue;
    if (defaultValue) getValue(serialize(defaultValue));
  }, [defaultValue]);

  useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <FormControl style={{ width: '100%' }}>
      <TextField
        ref={inputRef}
        onChange={handleChangeValue}
        error={!!error}
        defaultValue={t(defaultValue)}
        label={label}
        variant="outlined"
        fullWidth
        id={name}
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        {...rest}
        disabled={(permission || disabled) && !isGrid}
        onFocus={clearError}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  serialize: PropTypes.func,
  disabled: PropTypes.bool,
  isGrid: PropTypes.bool,
};

Input.defaultProps = {
  getValue: () => {},
  serialize: (value) => value,
  disabled: false,
  isGrid: false,
};

export default Input;
*/
